import Column from '@amzn/meridian/column';
import Select, { SelectOption } from '@amzn/meridian/select';
import { SelectOptionValue } from '@amzn/meridian/select/select-option';
import Text from '@amzn/meridian/text';
import React, { useState } from 'react';
import { createSearchRegExp } from 'src/utils/searchUtils';

interface FilterDropdownProps<T extends SelectOptionValue> {
  label: string;
  options: T[];
  value: T[];
  onChange: (value: T[]) => void;
}
const FilterDropdown = <T extends SelectOptionValue>({ options, value, label, onChange }: FilterDropdownProps<T>) => {
  const [searchQuery, setSearchQuery] = useState();
  const searchRegExp = createSearchRegExp(searchQuery);

  const matchedOptions = options.filter((option) => !searchQuery || searchRegExp.test(option.toString()));

  return (
    <Column spacing="100">
      <Text>{label}</Text>
      <Select
        size="small"
        value={value}
        onChange={onChange}
        searchQuery={searchQuery}
        onSearch={setSearchQuery}
        placeholder={`Select ${label}...`}
      >
        {matchedOptions.map((option: T) => (
          <SelectOption aria-label={`${label} ${option}`} label={option} value={option} key={option} />
        ))}
        {!matchedOptions.length ? (
          <Column alignmentVertical="center" spacing="300" spacingInset="500">
            <Text alignment="center">No results</Text>
          </Column>
        ) : null}
      </Select>
    </Column>
  );
};

export default FilterDropdown;
